export default {
  bind(el, binding) {
    if (!binding.value) return
    const src = binding.value.src
    const poster = binding.value.poster
    console.log(poster)
    console.log('bvalue', binding.value)

    if (poster) {
      return firebase.storage().ref(src).getDownloadURL().then(url => {
          return firebase.storage().ref(poster).getDownloadURL().then(poster_url => {
            el.src = url
            el.poster = poster_url
          })
      }).catch((error) => {
        console.log('ERROR', error)
        el.src = ''
        el.poster = ''
      })
    }
    firebase.storage().ref(src).getDownloadURL().then(url => {
      el.src = url
    }).catch((error) => el.src = '')
  },
  update(el, binding) {
    if (!binding.value) return
    const src = binding.value.src
    const poster = binding.value.poster
    console.log(poster)
    console.log('bvalue', binding.value)

    if (poster) {
      return firebase.storage().ref(src).getDownloadURL().then(url => {
          return firebase.storage().ref(poster).getDownloadURL().then(poster_url => {
            el.src = url
            el.poster = poster_url
          })
      }).catch((error) => {
        console.log('ERROR', error)
        el.src = ''
        el.poster = ''
      })
    }
    firebase.storage().ref(src).getDownloadURL().then(url => {
      el.src = url
    }).catch((error) => el.src = '')
  },
}
